import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const HolidaysHomework = () => {
     useEffect(() => {
        document.title = 'Holidays Homework -  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li> Academics </li> 
     <li>Holidays Homework </li> 
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Holidays Homework </h1>
         </div>
     </div>
     <div className="row">  
     <div className="col-lg-12">
     <nav>
     <div class="nav nav-tabs homeworktab" id="nav-tab" role="tablist">
       <button class="nav-link active" id="academics-tab" data-bs-toggle="tab" data-bs-target="#academics" type="button" role="tab" aria-controls="academics" aria-selected="true">Academics
       </button>
       <button class="nav-link" id="robitics-tab" data-bs-toggle="tab" data-bs-target="#robitics" type="button" role="tab" aria-controls="robitics" aria-selected="false">Robitics</button>
       
     </div>
   </nav>
   <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="academics" role="tabpanel" aria-labelledby="academics-tab"> 
        <div className="row">
        <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Nurseryhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p> Nursery</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/LKGhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p> LKG</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/UKGhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p> UKG</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p> Class I</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIIhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p>  Class II</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIIIhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p>  Class III</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIVhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p>  Class IV</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classVhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p>  Class V</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p>  Class VI</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIIhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p> Class VII</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIIIhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p> Class VIII</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIXhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p> Class IX</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
      <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classXhomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                 <p> Class  X</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
      </div>
        </div> 

        </div>
        <div class="tab-pane fade" id="robitics" role="tabpanel" aria-labelledby="robitics-tab">
             
        <div className="row">
        <div className="col-lg-4"> 
        <a href="https://webapi.entab.info/api/image/STPSFH/public/pdf/RoboticsHolidayHomework.pdf" target="_blank"> 
            <div class="sample-blk">
            <div>
                  <p> Robotics</p> 
            </div> 
            <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
            </LazyLoad>
            </div> 
        </a>  
        </div> 
        </div>
         </div>
</div>
</div>
</div>
</div>
</div>
<Footer/>
    </>
  )
}

export default HolidaysHomework
